module.exports = __webpack_public_path__ + "static/media/twitterbanner.9f5f1aa0.png";